import axios from "./api"

export default {
  getAllPrices() {
    return axios.get(`/api/priceproduct`).then(res => res.data)
  },
  getPriceById(id) {
    return axios.get(`/api/priceproduct/${id}`).then(res => res.data)
  },
  createPrice(price) {
    return axios.post(`/api/priceproduct`, price).then(res => res.data)
  },
  updatePrice(id, price) {
    return axios.put(`/api/priceproduct/${id}`, price).then(res => res.data)
  },
  removePrice(id) {
    return axios.delete(`/api/priceproduct/${id}`).then(res => res.data)
  }
}